const getters = {
  getClients: state => state.clients,
  getTotalByMont: state => state.totalByMonth,
  getOrders: state => state.orders,
  getTotalsOrders: state => state.totalsOrders
};

export default getters;
